import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { BreadcrumbItem } from '@/types/breadcrumb/breadcrumb.type';

interface BreadcrumbState {
    breadcrumbItems: BreadcrumbItem[];
}

const initialState: BreadcrumbState = {
    breadcrumbItems: [],
};

export const breadcrumbSlice = createSlice({
    name: 'breadcrumb',
    initialState,
    reducers: {
        setBreadcrumbItemsAction: (
            state,
            action: PayloadAction<BreadcrumbState['breadcrumbItems']>
        ) => {
            state.breadcrumbItems = action.payload;
        },
    },
});

export const { setBreadcrumbItemsAction } = breadcrumbSlice.actions;

export default breadcrumbSlice.reducer;
